import { put, call, takeLatest, select } from 'redux-saga/effects'
import startOfDay from 'date-fns/startOfDay'
import subWeeks from 'date-fns/subWeeks'
import { companyId } from '@/core/selectors/sessions'

import * as hiringAnalyticsView from '../reducks/hiringAnalytics'
import { getInterviewRequests } from '@/core/apiModules/hiringAnalytics'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchInterviewRequests() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getInterviewRequests, id, { start_at: subWeeks(startOfDay(new Date()), 8) })
    yield put(hiringAnalyticsView.fetchInterviewRequestsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchInterviewRequestsError(error))

    yield put(showSystemError(error))
  }
}

export default function* watchInterviewRequestsSaga() {
  yield takeLatest(hiringAnalyticsView.FETCH_INTERVIEW_REQUESTS, fetchInterviewRequests)
}
